import {
  editLayoutButtonId,
  editLayoutModalButtons,
  editLayoutModalCurrentLayout,
  editLayoutModalDragTip,
  editLayoutModalSubmit,
} from "constants/portalIds";
import { CHARACTERS_PATH } from "components/Characters/constants/charactersConsts";
import {
  ADDITIONAL_TUTORIAL_DATA_KEYS,
  TUTORIAL_STEP_TYPES,
} from "../consts/tutorialConsts";

export const getEditLayoutTutorialSteps = () => {
  return [
    {
      type: TUTORIAL_STEP_TYPES.TOOLTIP,
      sourceId: editLayoutButtonId,
      position: "bottom-end",
      width: 400,
      children: `If you are interested in customizing the layout of this sheet, click this button`,
      shouldRender: ({ page, id }) => page === CHARACTERS_PATH && id,
      hideNext: true,
      shouldIncrementStep: ({ additionalData }) =>
        additionalData[ADDITIONAL_TUTORIAL_DATA_KEYS.EDIT_LAYOUT_MODAL_OPEN],
    },
    {
      type: TUTORIAL_STEP_TYPES.TOOLTIP,
      sourceId: editLayoutModalCurrentLayout,
      position: "bottom-end",
      width: 400,
      children: `The layout used by the sheet is determined by the size of the screen. You can tell which layout will be displayed by looking for the white border on these buttons.`,
    },
    {
      type: TUTORIAL_STEP_TYPES.TOOLTIP,
      sourceId: editLayoutModalButtons,
      position: "bottom",
      width: 400,
      children: `Clicking one of these buttons lets you view and modify layouts other than the currently visible layout. If you don't care about how the app looks on smaller screens, ignore the other layouts`,
    },
    {
      type: TUTORIAL_STEP_TYPES.TOOLTIP,
      sourceId: editLayoutModalDragTip,
      position: "top",
      width: 400,
      children: `Click and drag the boxes below to modify the layout. If you want to hide a section, click the X in the corner.`,
    },
    {
      type: TUTORIAL_STEP_TYPES.TOOLTIP,
      sourceId: editLayoutModalDragTip,
      position: "top",
      width: 400,
      children: `If you want to reduce the number of columns, drag all the sections from one column to another. Empty columns will be collapsed.`,
    },
    {
      type: TUTORIAL_STEP_TYPES.TOOLTIP,
      sourceId: editLayoutModalSubmit,
      position: "top-end",
      width: 400,
      children: `Once you're satisfied with your new layout, hit the Submit button!`,
      hideNext: true,
      shouldIncrementStep: ({ additionalData }) =>
        !additionalData[ADDITIONAL_TUTORIAL_DATA_KEYS.EDIT_LAYOUT_MODAL_OPEN],
    },
  ];
};
